import { useNavigate } from 'react-router-dom';

const NotFoundScreen = () => {
  const navigate = useNavigate();
  document.body.style.backgroundColor = '#EAF6FF';

  const handleSubmit = () => {
    document.body.style.backgroundColor = '#FFF';
    navigate('/');
  };

  return (
    <>
      <div className="notfound_container">
        <span className="notfound_title">Sorry, page not found</span>
        <br />
        <br />
        <span className="notfound_description">
          We can’t seem to find the page you’re looking for.
          <br />
          Let&apos;s get you on the right page.
        </span>
        <br />
        <br />
        <button type="button" className="btn-round mb-3 btn btn-secondary" onClick={handleSubmit}>
          GO HOME
        </button>
      </div>
    </>
  );
};

export default NotFoundScreen;
